import Vue from 'vue'
import Vuex from 'vuex'
import localforage from 'localforage'
import uiModule from './modules/ui'
import searchModule from './modules/search'
import mapModule from './modules/map'
import audioModule from './modules/audio'
import { VuexPersistence } from 'vuex-persist'

const Bus = new Vue()
window.Bus = Bus
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

const vuexLocalForage = new VuexPersistence({
  key: 'kulturarv',
  storage: localforage,
  asyncStorage: true
  // storage: window.localStorage
})

const vuexSessionStorage = new VuexPersistence({
  key: 'kulturarv',
  storage: window.sessionStorage,
  asyncStorage: false
})

export default new Vuex.Store({
  modules: {
    ui: uiModule,
    search: searchModule,
    map: mapModule,
    audio: audioModule
  },
  strict: debug,
  plugins: [vuexSessionStorage.plugin]
})
